import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../components/content/axiosConfig';
import { queryKeys } from './queryKeys';

export function useLengthUnits(params = {}, options = {}) {
  return useQuery({
    queryKey: queryKeys.lengthUnits(params),
    queryFn: async () => {
      const response = await axiosInstance.get('/api/LengthUnit/GetAll', { params });
      return response.data;
    },
    staleTime: 60 * 60_000,
    ...options,
  });
}

export function normalizeUnitsData(data) {
  if (Array.isArray(data)) return data;
  return data?.data ?? [];
}
